export const baseStaticURL = process.env.REACT_APP_STATIC_ASSETS_ENDPOINT
